<template>
  <div class="btn-group btn-group-sm">
    <button v-if="can_access('user','modify')" class="btn btn-edit" title="Edit User" @click="showModal('edit')"><i class="fa fa-edit"></i></button>
    <button v-if="can_access('user','modify')" class="btn btn-gray" title="Copy User" @click="showModal('copy')"><i class="fa fa-copy"></i></button>
    <button v-if="can_access('user','modify') && !row.deleted_at" class="btn btn-danger" title="Inactive User" @click="showModal('delete')"><i class="fa fa-lock"></i></button>

    <b-modal ref="edit-user-out" :title="'Add User'" size="xl" hide-footer>
      <AddUserForm :rows="rowData" @forceRerender="userFormReRender"/>
    </b-modal>
  </div>
</template>
<script>
import $ from 'jquery';
import AddUserForm from '@/components/Accounts/AddUserForm';
import common from '@/assets/js/common.js';
export default {
  props: ['row', 'nested','refresh'],
  mixins: [common],
  data(){
    return {
      show: 1,
      rowData:{},
      action:''
    }
  },
  components: {  AddUserForm },
  mounted () {
    //$(this.$el).find('button[title]').tooltip()
  },
  computed: {
  },
  methods: {
    userFormReRender(response) {
      if(response.code==0){
        this.$refs['edit-user-out'].hide();
        this.show = 1;
        this.refresh();
        this.$toasted.success("Successfully Added",{duration:1000});
      }
    },
    toggleNestedComp (comp) {
      const { nested } = this
      if (nested.comp === comp) return nested.$toggle()
      nested.$toggle(comp, true)
    },
    showModal(action) {
        this.action = action;
        if(action=='edit'){
            this.rowData = this.duplicate(this.row);
            this.rowData.action = 'edit'
        }
        else if(action=='delete'){
          if(confirm("Do you really want to inactive?")){
            this.show = false;
            this.rowData = this.duplicate(this.row);
            this.rowData.action = 'delete';
            this.rowData.status = 0;
          }else return;
        }
        else if(action=='copy'){
          this.rowData = this.duplicate(this.row);
          this.rowData.action = 'create'
          this.rowData.id = '';
        }
        this.$refs['edit-user-out'].show()
    },
  }
}
</script>
<style>
.-nested-comp-open-btn {
  color: #fff !important;
  background-color: #337ab7 !important;
}
dd, dt {
    line-height: 1.42857143;
}
</style>
